import React from "react";
import NoDataImg from "../../static/icons/no-data.png";

export const DocumentNotFound = ({ onClose }) => {
  return (
    <div className="text-center">
      <img className="img-fluid" src={NoDataImg} alt="no data found" />
      <p className="text-muted mt-3">Documents Not Found!</p>
      <a className="btn btn-link" onClick={onClose}>
        Close
      </a>
    </div>
  );
};
